import { get, post } from '@/unit/request.js'
export default {
    list () {
        return get('/notice/list')
    },
    del (data) {
        return post('/notice/delete', data)
    },
}